import { notification } from 'antd'
import { useRiseUpAPIV1 } from 'hooks/useRiseUpAPIV1'
import InvestmentAmount from './InvestmentAmount'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { consoleLog } from 'utils/simpleLogger'
import Verify from './Verify'
import AcknowledgementPage from './AcknowledgementPage'
import PaymentSelection from './PaymentSelection'
import SuccessReinvestment from './SuccessReinvestment'
import Payments from './Payments'
import { Navigate } from 'react-router-dom'

const ReinvestRegA = () => {
  const [formState, setFormState] = useState({
    step: '1',
  })
  const [currentStage, setCurrentStage] = useState(1)

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    control,
    trigger,
    reset,
    formState: { errors, isValid },
    clearErrors,
    unregister
  } = useForm({ mode: 'onSubmit' })
  const { getIPAddress } = useRiseUpAPIV1()

  const [paymentOptionSelected, setPaymentOptionSelected] = useState<string | null>(
    getValues('investingProfile.paymentMethod'),
  )

  const validateFields = (data: []) => {
    trigger(data)
  }

  const onSubmit = (data: any) => {
    consoleLog('Form data submitted', data)
  }

  const nextStep = (page: string) => {
    setFormState({ step: page })
  }

  const previousStep = (page: string) => {
    setFormState({ step: page })
  }

  const fetchUserIpAddress = async () => {
    const ipAddress = await getIPAddress()
    setValue('ipAddress', ipAddress)
  }

  // destroy warning notif on every step change
  useEffect(() => {
    fetchUserIpAddress()
    notification.destroy('form-notif')
    clearErrors()
    window.scrollTo(0, 0)
  }, [formState])

  const renderFormStep = () => {
    switch (formState.step) {
      case '1':
        return (
          <Verify
            registerField={register}
            handleSubmit={onSubmit}
            errors={errors}
            isValid={isValid}
            useForm={useForm}
            nextStep={nextStep}
            previousStep={previousStep}
            watch={watch}
            control={control}
            getValues={getValues}
            setValue={setValue}
            currentStage={currentStage}
            setCurrentStage={setCurrentStage}
            validateFields={validateFields}
            clearErrors={clearErrors}
            currentStep={formState.step}
            reset={reset}
          />
        )
      case '2':
        return (
          <InvestmentAmount
            registerField={register}
            handleSubmit={onSubmit}
            errors={errors}
            isValid={isValid}
            useForm={useForm}
            nextStep={nextStep}
            previousStep={previousStep}
            watch={watch}
            control={control}
            getValues={getValues}
            setValue={setValue}
            currentStage={currentStage}
            setCurrentStage={setCurrentStage}
            validateFields={validateFields}
            clearErrors={clearErrors}
            reset={reset}
            currentStep={Number(formState.step)}
          />
        )

      case '3':
        return (
          <AcknowledgementPage
            registerField={register}
            handleSubmit={onSubmit}
            errors={errors}
            isValid={isValid}
            useForm={useForm}
            nextStep={nextStep}
            previousStep={previousStep}
            watch={watch}
            control={control}
            getValues={getValues}
            setValue={setValue}
            currentStage={currentStage}
            setCurrentStage={setCurrentStage}
            validateFields={validateFields}
            clearErrors={clearErrors}
            currentStep={formState.step}
          />
        )

      case '4':
        return (
          <PaymentSelection
            registerField={register}
            handleSubmit={onSubmit}
            errors={errors}
            isValid={isValid}
            useForm={useForm}
            nextStep={nextStep}
            previousStep={previousStep}
            setPaymentOptionSelected={setPaymentOptionSelected}
            getValues={getValues}
            setValue={setValue}
            currentStage={currentStage}
            setCurrentStage={setCurrentStage}
            currentStep={formState.step}
            unregister={unregister}
          />
        )

      case '5':
        return (
          <Payments
            registerField={register}
            handleSubmit={onSubmit}
            errors={errors}
            isValid={isValid}
            useForm={useForm}
            nextStep={nextStep}
            previousStep={previousStep}
            paymentOptionSelected={paymentOptionSelected}
            watch={watch}
            control={control}
            getValues={getValues}
            setValue={setValue}
            currentStage={currentStage}
            setCurrentStage={setCurrentStage}
            currentStep={Number(formState.step)}
            reset={reset}
            unregister={unregister}
          />
        )

      case 'Success':
        return <SuccessReinvestment getValues={getValues} reset={reset} currentStep={formState.step} />

      default:
        return <Navigate to={'registration'} />;
    }
  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>{renderFormStep()}</form>
      {process.env.NODE_ENV === 'development' ? <pre>{JSON.stringify(watch(), null, 2)}</pre> : null}
    </div>
  )
}

export default ReinvestRegA
